import * as React from "react";
import styles from "./Projects.module.css";

const Projects = () => {
  return (
    <div className={styles.container}>
      <a href="/the-shape-of-flight">
        <img src="mainpage/IMG_0188.jpeg" loading={"lazy"}></img>
        <div className={styles.imgText}>The Shape Of Flight</div>
      </a>
      <a href="/to-brancusi">
        <img src="Brancusi/10.png" loading={"lazy"}></img>
        <div className={styles.imgText}>To Brancusi...</div>
      </a>
      <a href="/the-modern-artisan">
        <img
          src="thema/20.png"
          loading={"lazy"}
          className={styles.imgFromTop}
        ></img>
        <div className={styles.imgText}>
          The Modern Artisan Net-A-Porter x The King's Foundation
        </div>
      </a>
      {/* <a href="/gmaro-magazine">
        <img src="/gmaro5.png" loading={"lazy"}></img>
        <div className={styles.imgText}>GMARO Magazine Editorial</div>
      </a> */}
      <a href="/talent-of-tomorrow">
        <img
          className={styles.imgFromTop}
          src="talentoftomorrow/15.png"
          loading={"lazy"}
        ></img>
        <div className={styles.imgText}>
          Fashion Accelerator Programe by GFW, PVH Corp, and DAZED
        </div>
      </a>
      {/* <a href="/apres-chic">
        <img src="/projects3.jpg" loading={"lazy"}></img>
        <div className={`${styles.imgText} ${styles.white}`}>Après-Chic</div>
      </a> */}
    </div>
  );
};

export default Projects;
